var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9977 8C17.9977 6.4087 17.3656 4.88258 16.2406 3.75736C15.1155 2.63214 13.5896 2 11.9985 2C10.4074 2 8.88145 2.63214 7.75637 3.75736C6.6313 4.88258 5.99924 6.4087 5.99924 8C5.99924 15 2.99963 17 2.99963 17H20.9973C20.9973 17 17.9977 15 17.9977 8Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7282 21C13.5524 21.3031 13.3001 21.5547 12.9965 21.7295C12.693 21.9044 12.3488 21.9965 11.9985 21.9965C11.6481 21.9965 11.3039 21.9044 11.0004 21.7295C10.6968 21.5547 10.4445 21.3031 10.2687 21",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.255025f2ba8d33cb91050aa9c6663ac6.svg";
export { ForwardRef as ReactComponent };